<template>
    <div class="treatment-view-mode-select">
        <span class="label">{{ $translate('view') }}:</span>

        <b-button
            v-b-tooltip.hover
            :title="$translate('slide_view')"
            variant="transparent"
            :pressed="currentView === views.WELL_CARDS"
            @click="changeCurrentView(views.WELL_CARDS)"
        >
            <i class="fa fa-th-large" />
        </b-button>

        <b-button
            v-b-tooltip.hover
            :title="$translate('table_view')"
            variant="transparent"
            :pressed="currentView === views.PERFORMANCE_TABLE"
            @click="changeCurrentView(views.PERFORMANCE_TABLE)"
        >
            <i class="fa fa-bars" />
        </b-button>

        <b-button
            v-if="!isFdaFriendly"
            v-b-tooltip.hover
            :title="$translate('istanbul_view')"
            variant="transparent"
            class="istanbul-button"
            :pressed="currentView === views.ISTANBUL_TABLE"
            @click="changeCurrentView(views.ISTANBUL_TABLE)"
        >
            <i class="fa fa-bars" />
        </b-button>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { TREATMENT_PAGE_VIEWS } from '../../../business/const'

export default {
    name: 'TreatmentViewModeSelect',
    computed: {
        ...mapState({
            currentView: state => state.navigation.currentView
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        }),
        views() {
            return TREATMENT_PAGE_VIEWS
        }
    },
    methods: {
        changeCurrentView(view) {
            if (this.currentView !== view) {
                this.$store.dispatch('navigation/switchTreatmentView', view)
                this.$router.update({ view })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.treatment-view-mode-select {
    display: flex;
    align-items: center;

    .label {
        color: $light;
        margin-right: 0.5rem;
    }
    button {
        line-height: 100%;
    }
    .istanbul-button {
        transform: rotate(90deg);
    }

    .fa-th-large,
    .fa-bars {
        font-size: 18pt;
        margin: 0 0.25rem;
        -webkit-text-stroke: 0.1rem $dark-4;
    }
}
</style>
